import React, { useContext, useState } from "react";
import RegistrationContext from "../../context/registration/registrationContext";
import AdminRegistrationContext from "../../context/adminRegistration/adminRegistrationContext";
import * as GrIcons from "react-icons/gr";

const SiteItem = ({ data, setSite, selectedSite }) => {
  const {
    name,
    charter,
    distance,
    address: { state, address_1, city, zip },
  } = data;
  return (
    <tr>
      <td>{name}</td>
      <td>{charter}</td>
      <td>{`${address_1}, ${city}, ${state}, ${zip}`}</td>
      <td>{distance}</td>
      {Object.keys(selectedSite).length === 0 && (
        <td>
          <div
            onClick={() => {
              setSite(data);
            }}
            className="btn btn-llac-light-grey"
          >
            Select
          </div>
        </td>
      )}
    </tr>
  );
};

const SiteZipSearchModal = ({ setLocationInfo }) => {
  const adminRegistrationContext = useContext(AdminRegistrationContext);
  const { setFormModal, getOrientationInformation } = adminRegistrationContext;
  const registrationContext = useContext(RegistrationContext);
  const { getZipLocations, zipSites } = registrationContext;
  const [radius, setRadius] = useState(20);
  const [zipcode, setZipcode] = useState("");
  const [selectedSite, setSelectedSite] = useState({});

  const onSubmit = (e) => {
    e.preventDefault();
    setSelectedSite({});
    getZipLocations(zipcode, radius);
  };

  return (
    <div id="site-zip-search-modal" className="modal">
      <div className="zip-modal-content modal-content">
        <div className="top-bar">
          <GrIcons.GrFormClose
            className="close-icon"
            onClick={() => setFormModal("siteZipSearchModal", false)}
          />
          <h2>Search Sites by Zipcode</h2>
        </div>
        <div className="modal-body">
          <form className="form" onSubmit={onSubmit}>
            <div className="search-bar">
              <input
                type="text"
                value={zipcode}
                onChange={(e) => setZipcode(e.target.value)}
                placeholder="Enter Zipcode"
              />
              <select
                name="radius"
                value={radius}
                onChange={(e) => setRadius(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    onSubmit();
                  }
                }}
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <input
                type="submit"
                value="Search Sites"
                className="btn btn-llac-light-green"
              />
            </div>
          </form>
          <div className="search-results">
            <table>
              <tr>
                <th>Name</th>
                <th>Charter</th>
                <th>Address</th>
                <th>Distance</th>
                {Object.keys(selectedSite).length === 0 && <th>Action</th>}
              </tr>
              {zipSites.length > 0 ? (
                Object.keys(selectedSite).length !== 0 ? (
                  <SiteItem
                    data={selectedSite}
                    setSite={setSelectedSite}
                    selectedSite={selectedSite}
                  />
                ) : (
                  zipSites.map((item) => {
                    return (
                      <SiteItem
                        data={item}
                        setSite={setSelectedSite}
                        selectedSite={selectedSite}
                      />
                    );
                  })
                )
              ) : null}
            </table>
          </div>
        </div>
        <div className="bottom-bar">
          <div className="btns">
            {Object.keys(selectedSite).length !== 0 && (
              <div
                onClick={() => {
                  setLocationInfo({
                    id: selectedSite.id,
                    name: selectedSite.name,
                    charter: selectedSite.charter,
                    address: `${selectedSite.address.address_1}, ${selectedSite.address.city}, ${selectedSite.address.state}, ${selectedSite.address.zip}`,
                    coordinates: selectedSite.coordinates,
                  });
                  getOrientationInformation(selectedSite.id);
                  setFormModal("siteZipSearchModal", false);
                }}
                className={`btn btn-llac-dark-green`}
              >
                Confirm Site
              </div>
            )}
            <div
              className="btn btn-l4l-dark"
              onClick={() => setFormModal("siteZipSearchModal", false)}
            >
              Close
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SiteZipSearchModal;
